import React, {
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import Alert, { AlertColor } from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";

export interface AlertBoxRef {
  open: (message: string, severity?: AlertColor) => void;
  close: () => void;
}

const AlertBox = forwardRef<AlertBoxRef>((props, ref) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<AlertColor>("success");

  useImperativeHandle(ref, () => ({
    open(msg: string, sev: AlertColor = "success") {
      setMessage(msg);
      setSeverity(sev);
      setOpen(true);
    },
    close() {
      setOpen(false);
    },
  }));

  return (
    <Snackbar
      open={open}
      // autoHideDuration={5000}
      // onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={[ window.innerHeight == 768?{"&.MuiSnackbar-root": { mt: 20, }}:{"&.MuiSnackbar-root": { mt: 0, }} ]}
    >
      <Alert
        severity={severity}
        sx={{ display: "flex", alignItems: "flex-start", 
         "& .MuiAlert-action": { display: "flex", flexDirection: "row", alignItems: "flex-start", paddingTop: "2px" },
         width:'500px', height:'84px', 
        borderRadius:'4px', border:'1px solid #DC1919', color:'#DC1919', fontSize:'14px' }}
        action={
          <>
            {/* Got it button */}
            <Button
              color="inherit"
              size="small"
              onClick={() => setOpen(false)}
              sx={{fontWeight:'600', fontSize:'14px', whiteSpace:'nowrap', px:0}}
            >
              GOT IT
            </Button>

            {/* Close icon (optional) */}
            {/* <IconButton
              color="inherit"
              size="small"
              onClick={() => setOpen(false)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton> */}
          </>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
});

export default AlertBox;
